import { render, staticRenderFns } from "./BaseSummaryBox.vue?vue&type=template&id=810e8176&scoped=true&"
import script from "./BaseSummaryBox.vue?vue&type=script&lang=js&"
export * from "./BaseSummaryBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseSummaryBox.vue?vue&type=style&index=0&id=810e8176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810e8176",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
